import React, { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import jsonData from "../Data.json";
import AdminImg from "../../Img/viewer.png";
import Viewer from "../../Img/viewer.png";
// import campraImg from "../../Img/LOGORepository.png"
import campraImg from "../../Img/CT.png";
import CategoryList from "./CategoryList";
import myarticles from "../../Img/new article.png";
import back from "../../Img/new home.png";
import adminpage from "../../Img/admin page.png";
import { API_BASE_URL } from "../../utils/config";
import ReactPaginate from "react-paginate"; // for pagination
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"; // icons form react-icons
import { IconContext } from "react-icons";
// import adminpage from '../Img/admin page.png';

import axios from "axios";
import Spinner from "../Spinner";
import { Dropdown } from "react-bootstrap";
import TopNavBar from "../TopNavBar";
import SideBar from "../SideBar";
import HamburgerNavigation from "../HamburgerNavigation";
import InnerHamburgerNavigation from "../InnerHamburgerNavigation";
import { toast } from "react-toastify";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import NewTopNavBar from "../NewTopNavBar";
import { filterDataByUserTags } from "../../utils/commons";
import AllPostsLike from "./AllPostsLike";
const SearchResults = () => {
  const [collaps, setCollaps] = useState(true);
  // console.log("ResultSearch New= ", jsonData);
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  const [query, setQuery] = useState(localStorage.getItem("searchQuery"));
  const [searcQuery, setSearchQuery] = "";
  // const query = localStorage.getItem('searchQuery');
  let bearerToken = localStorage.getItem("jwt_token");
  const [filteredResults, setFilterResults] = useState([]);
  const [isButtonVisible, setButtonVisible] = useState(true);
  const [loading, setLoding] = useState(false);
  const [count, setcount] = useState(1);
  const [allCategories, setALLCategories] = useState([]);
  const [page, setPage] = useState(0);
  const [filterData, setFilterData] = useState();
  const n = 4;
  let catagoryId = localStorage.getItem("catagoryId");
  let subcategoryId = localStorage.getItem("subcategoryId");
  // Filter JSON data based on the search query
  //  const filteredResults = jsonData.filter((item) =>
  //   item.title.toLowerCase().includes(query.toLowerCase())
  //  );
  const handleInputChange = (e) => {
    const inputQuery = e.target.value;
    setQuery(inputQuery);
  };
  const handleSearch = (e) => {
    e.preventDefault(); // Prevent form submission
    if (query == "") {
      toast.error("Enter text to perform a search.");
      return;
    } else if (query.length == 1) {
      toast.error("Please provide additional text to refine your search.");
      return;
    }
    setLoding(true);
    console.log("search");

    let apiEndPoint = "";
    if (subcategoryId) {
      apiEndPoint = `${API_BASE_URL}/wp-json/wp/v2/posts?search='${query}'&categories=${subcategoryId}&per_page=100`;
    } else if (catagoryId) {
      apiEndPoint = `${API_BASE_URL}/wp-json/wp/v2/posts?search='${query}'&categories=${catagoryId}&per_page=100`;
    } else {
      apiEndPoint = `${API_BASE_URL}/wp-json/wp/v2/posts?search='${query}'&per_page=100`;
    }

    axios
      .get(apiEndPoint, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setLoding(false);
        // setRes(response.data);
        // alert("sdf")
        console.log("response=", response.data);
        //
        response.data = filterDataByUserTags(response.data);
        const normalPost = [];
        const filterPosts = response.data.filter((data) => {
          console.log("50=", data.title.rendered);
          if (data.title.rendered.toLowerCase().includes(query.toLowerCase())) {
            return data;
          } else {
            normalPost.push(data);
          }
        });
        filterPosts.push(...normalPost);
        //
        setFilterResults(filterPosts);
        // setFilterResults(response.data.slice(0, 8))
        // setApiRespose(response.data.slice(0, 8))
      })
      .catch((err) => {
        setLoding(false);
        // alert(err)
      });
  };

  const navigate = useNavigate();

  const search = () => {
    setLoding(true);
    console.log("search");
    let apiEndPoint = "";
    if (subcategoryId) {
      apiEndPoint = `${API_BASE_URL}/wp-json/wp/v2/posts?search=${query}&categories=${subcategoryId}&per_page=100`;
    } else if (catagoryId) {
      apiEndPoint = `${API_BASE_URL}/wp-json/wp/v2/posts?search=${query}&categories=${catagoryId}&per_page=100`;
    } else {
      apiEndPoint = `${API_BASE_URL}/wp-json/wp/v2/posts?search=${query}&per_page=100`;
    }
    axios
      .get(apiEndPoint, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setLoding(false);
        // setRes(response.data);
        // alert("sdf")
        console.log("response=", response.data);
        //
        response.data = filterDataByUserTags(response.data);
        const normalPost = [];
        const filterPosts = response.data.filter((data) => {
          console.log("50=", data.title.rendered);
          if (data.title.rendered.toLowerCase().includes(query.toLowerCase())) {
            return data;
          } else {
            normalPost.push(data);
          }
        });
        filterPosts.push(...normalPost);
        //
        setFilterResults(filterPosts);
        // setFilterResults(response.data.slice(0, 8))
        // setApiRespose(response.data.slice(0, 8))
      })
      .catch((err) => {
        setLoding(false);
        // alert(err)
      });
  };

  useEffect(() => {
    if (!bearerToken) {
      navigate("/");
    } else {
      let sessionId = sessionStorage.getItem("sessionId");
      if (!sessionId) {
        let sessionId = Math.floor(Math.random() * 100000);
        sessionStorage.setItem("sessionId", sessionId);
        navigate("/all-articles");
      } else {
        setLoding(true);
        search();
        const fetchCategories = async () => {
          // setLoading(true);
          try {
            const response = await axios.get(
              `${API_BASE_URL}/wp-json/custom-category/v1/get-all-categories`,
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                  "Content-Type": "application/json",
                },
              }
            );
            const categoryData = response.data.map((category) => ({
              id: category.id,
              name: category.name,
            }));
            console.log("catData=", categoryData);
            setALLCategories(categoryData);
          } catch (error) {
            console.error("Error fetching categories:", error);
          } finally {
            // setLoading(false);
          }
        };

        fetchCategories();
      }
    }
  }, []);

  useEffect(() => {
    if (query == "") {
      // setQuery(localStorage.getItem("searchQuery"))
      // localStorage.removeItem("searchQuery")
      // // alert(query.length)
      // setFilterResults([])
      // setFilterData([])
    } else {
      setFilterData(
        filteredResults.filter((item, index) => {
          return (index >= page * n) & (index < (page + 1) * n);
        })
      );
    }
  }, [
    page,
    allCategories?.length,
    filteredResults?.length,
    query?.length == 0,
  ]);
  const gotToArticlePage = (postId) => {
    console.log(postId);
    // localStorage.setItem("postId", postId)
    navigate(`/single-article?id=${postId}`);
  };

  const changeCollapsState = () => {
    if (collaps) {
      setCollaps(false);
    } else {
      setCollaps(true);
    }
  };

  //

  const extractSentences = (text, query) => {
    const sanitizedText = text.replace(
      /<\/?(img|iframe|yourtagnamehere)[^>]*>/g,
      ""
    );
    const searchResultsData = [];

    const sentences = sanitizedText.split(/[\.\?\!]/g);
    const filteredSentences = sentences.filter((sentence) =>
      sentence.toLowerCase().includes(query.toLowerCase())
    );

    console.log("line230=", filteredSentences);

    if (filteredSentences.length > 0) {
      searchResultsData.push(...filteredSentences.slice(0, 10));
      // Show the first ten sentences that contain the query
    } else {
      searchResultsData.push(...sentences.slice(0, 2));
      // If no sentences contain the query, show the first ten sentences
    }

    return searchResultsData;
  };

  // const highlightQuery = (text, query) => {
  //   const regex = new RegExp(query, 'gi');
  //   return text.replace(regex, (match) => `<span style="background-color: yellow;">${match}</span>`);
  // };

  // const highlightQuery = (text, query) => {
  //   const regex = new RegExp(`(?<=<[^>]*>)([^<]*${query}[^<]*)(?=<\/[^>]*>)`, 'gi');

  //   return text.replace(regex, (match) => `<span style="background-color: yellow;">${match}</span>`);
  // };

  const highlightQuery = (text, query) => {
    if (!query) {
      return text; // Return the original text if query is empty
    }
    const regex = new RegExp(query, "gi");
    return text.replace(
      regex,
      (match) => `<span style="background-color: yellow;">${match}</span>`
    );
  };
  //

  return (
    //
    <div>
      <div className="row g-0">
        <div className="col-12 hamburger">
          <InnerHamburgerNavigation />
        </div>
        {/* <div
          style={{ width: collaps ? "" : "5vw" }}
          className={collaps ? 'col-3 sidebarBackground sidebar' : 'col-1 sidebarBackground sidebar'}
        // className="col-3 "
        >
         
          <SideBar collaps={changeCollapsState} />
          
        </div> */}
        <div
          style={{ minHeight: "90vh" }}
          className={
            collaps ? "column right-column  col" : "column right-column  col "
          }
        >
          <div className="w-100">
            <div className="top-nav">
              {/* <TopNavBar /> */}
              <NewTopNavBar />
            </div>
            <HamburgerNavigation />
            {/* 
              <button className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 "><i className="fas fa-bars" ></i></button> */}
          </div>
          {/*  */}

          <div className="search-back w-100">
            {console.log("filteredResults=", filteredResults)}
            {/* {query && filteredResults.length > 0 ? */}
            <div className="search-results w-100">
              {/* {query && filteredResults.length > 0 ? <h3 className='fw-bold py-3 text-center'>Search Results</h3> : <h1 className='text-center mt-5 pt-5'>Data Not Found</h1>} */}
              <h3
                style={{ color: "#092360" }}
                className="fw-bold pt-4 text-center"
              >
                Search for Articles
              </h3>
              <div className="row g-0">
                <div className="col-lg-3 col-sm-2"></div>

                <div className="col-lg-6 col-sm-8">
                  <form
                    role="search"
                    method="get"
                    className="search-form mb-5 mt-1 w-100"
                    onSubmit={handleSearch}
                  >
                    <label style={{ flex: "1", background: "#ffffff59" }}>
                      <input
                        type="text"
                        className="search-field"
                        placeholder="Search..."
                        value={query}
                        onChange={handleInputChange}
                      />
                    </label>
                    <button type="submit" className="search-submit">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"
                        />
                      </svg>
                    </button>

                    {/* <SearchResults results={suggestions} /> */}
                  </form>
                </div>
                <div className="col-lg-3 col-sm-2"></div>
              </div>
              {/* serach result Data start */}

              <div className="post-container1 row  container mx-auto">
                <div className="" style={{ minHeight: "48vh" }}>
                  {query && filterData?.length > 0 ? <h4>Results:</h4> : ""}
                  {console.log("line356=", filterData)}
                  {
                    loading ? (
                      <Spinner />
                    ) : // query &&
                    filterData?.length > 0 ? (
                      filterData.map((result, index) => {
                        // console.log("192=", showCatagory)
                        return (
                          // <div className=" col-12 col-md-4 col-sm-6 col-xl-3 mb-3">
                          <div className=" col-8 mb-3">
                            <div
                              style={{ cursor: "pointer" }}
                              className=""
                              onClick={() => gotToArticlePage(result.id)}
                            >
                              {/* <h4>{extractSentences(result.title.rendered, query)}</h4> */}
                              <h5
                                style={{ color: "#092360" }}
                                dangerouslySetInnerHTML={{
                                  __html: highlightQuery(
                                    result.title.rendered,
                                    query
                                  ),
                                }}
                              />
                              <AllPostsLike postId={result.id} />
                              {/* {console.log("total content=", highlightQuery("sddd", query))} */}
                              {result.excerpt.rendered && (
                                <div className="pt-2">
                                  {extractSentences(
                                    result.excerpt.rendered,
                                    query
                                  ).map((sentence, index) => {
                                    console.log("line347", sentence);
                                    return (
                                      <p
                                        key={index}
                                        dangerouslySetInnerHTML={{
                                          __html: highlightQuery(
                                            sentence,
                                            query
                                          ),
                                        }}
                                      />
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                            <hr />
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center w-100 my-5">
                        <h1>No results found</h1>
                      </div>
                    )
                    // <h1 className='text-center mt-5 pt-5'>Data Not Found</h1>
                  }
                  {/*  */}
                </div>

                {filterData?.length > 0 ? (
                  <ReactPaginate
                    containerClassName={"pagination-package"}
                    pageClassName={"page-item-package"}
                    activeClassName={"active-package"}
                    onPageChange={(event) => setPage(event.selected)}
                    pageCount={Math.ceil(filteredResults.length / n)}
                    breakLabel="..."
                    previousLabel={
                      <IconContext.Provider
                        value={{ color: "#B8C1CC", size: "36px" }}
                      >
                        {/* <AiFillLeftCircle /> */}
                        <div className="prev-btn">
                          <FaArrowLeft size={20} color="black" /> Previous{" "}
                        </div>
                      </IconContext.Provider>
                    }
                    nextLabel={
                      <IconContext.Provider
                        value={{ color: "#B8C1CC", size: "36px" }}
                      >
                        {/* <AiFillRightCircle /> */}
                        <div className="next-btn">
                          {" "}
                          Next <FaArrowRight size={20} color="black" />{" "}
                        </div>
                      </IconContext.Provider>
                    }
                  />
                ) : (
                  ""
                )}

                {/*  */}
              </div>

              {/* serach result Data end*/}

              {/* <div className="post-container1 row  container mx-auto">
                {loading ? <Spinner /> :
                  query && filteredResults.length > 0 ? filteredResults.map((val, index) => {
                    // const img_src=RandomImage();
                    let featureImage = '';
                    if (val.yoast_head_json.og_image !== undefined) {
                      featureImage = val?.yoast_head_json?.og_image[0].url

                    } else {
                      featureImage = campraImg;
                    }
                    let showCatagory = "";

                    for (let i = 0; i < allCategories.length; i++) {
                      if (allCategories[i].id == val.categories[0]) {
                        showCatagory = allCategories[i].name
                        console.log("catagory Name=", showCatagory)

                        // return showCatagory
                      }
                    }
                    const fullString = showCatagory;

                    // Use regular expression to extract value within parentheses
                    const match = fullString?.match(/\(([^)]+)\)/);

                    // Check if there is a match and extract the value
                    const epmValue = match ? match[1] : null;

                    console.log(epmValue);

                    // console.log("192=", showCatagory)
                    return (
                      <div className=" col-12 col-md-4 col-sm-6 col-xl-3 mb-3">
                       
                        <div className='hyperlinkCard' onClick={() => gotToArticlePage(val.id)} >

                          <div className="post p-3">
                          
                            <div>
                              <img className='mb-3' src={featureImage} alt="" style={{ width: '100%', height: '20vh' }} />
                            </div>
                            <h2 className='elepse-post-heading'>{val.title.rendered}</h2>
                           
                            <p className='elipse-para' dangerouslySetInnerHTML={{ __html: val.excerpt.rendered }}></p>
                            <div className="post-me">
                              <small style={{ color: '#a09e9e' }}>{val.date.slice(0, 10)}</small>
                              <small style={{ color: '#a09e9e' }}>{epmValue}</small>
                              


                            </div>
                          </div>
                        </div>
                       
                      </div>
                    )
                  }) : <div className='text-center w-100 my-5'>

                   
                    <h1>No results found</h1>
                  </div>
                  // <h1 className='text-center mt-5 pt-5'>Data Not Found</h1>
                }

              </div> */}

              {/* {filteredResults.length > 0 && <div className='text-end me-5 pe-5 w-100 mb-4'>
                {isButtonVisible && (
                  <button onClick={moreBtn} className="btn-primary ">
                    More...
                  </button>
                )}
              </div>} */}
            </div>

            {/* // :
              //   <h1 className='text-center mt-5 pt-5'>Data Not Found</h1>
              // }
              : <div className='text-center w-100 my-5'>
                <h1>No results found</h1>
              </div>
            } */}

            {/* <div className='text-end me-5 pe-5 w-100 mb-4'>
              <Link to="" className="hyperlinkCard ">More...</Link>
            </div> */}
          </div>
        </div>

        {/* // */}
      </div>
    </div>
  );
};

export default SearchResults;
